// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RWiC","clinicsSelect":"styles_clinicsSelect__397nD"};